import { render } from "./BlockGalleryModal.vue?vue&type=template&id=999c9fb2&scoped=true"
import script from "./BlockGalleryModal.vue?vue&type=script&lang=js"
export * from "./BlockGalleryModal.vue?vue&type=script&lang=js"

import "./BlockGalleryModal.vue?vue&type=style&index=0&id=999c9fb2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-999c9fb2"]])

export default __exports__